// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookPreview_bookContainer__eStP6 {
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative;
    font-family: 'Merriweather', Georgia, serif;
    background: linear-gradient(135deg, #CAC9C9 0%, #CAC9C9 100%);
    overflow: hidden;
    z-index: 9999;
  }
  .BookPreview_scrollThumb__iNU2o{
    overflow: hidden;
  }
  
  /* Library sidebar styles */
.BookPreview_librarySidebar__DngGd {
  position: fixed;
  width: 320px;
  height: 100vh;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  z-index: 100;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* Updated background properties for glassmorphism effect */
 -webkit-backdrop-filter: blur(15px);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgb(0 0 0 / 31%);
  backdrop-filter: blur(4px);
}
  
  .BookPreview_librarySidebar__DngGd.BookPreview_active__MHU-O {
    transform: translateX(0);
  }
  
  .BookPreview_libraryHeader__gg2GP {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
  }
  
  .BookPreview_libraryHeader__gg2GP h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
    font-weight: 700;
  }
  
  .BookPreview_closeButton__\\+dDyu {
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
    transition: color 0.2s;
  }
  
  .BookPreview_closeButton__\\+dDyu:hover {
    color: #000;
  }
  
  .BookPreview_chapterList__P-t4U {
    padding: 20px;
    overflow-y: auto;
    flex-grow: 1;
  }
  
  .BookPreview_chapterList__P-t4U h3 {
    margin: 0 0 5px 0;
    font-size: 1.2rem;
    color: #333;
  }
  
  .BookPreview_author__A3q9\\+ {
    margin: 0 0 20px 0;
    color: #666;
    font-style: italic;
  }
  
  .BookPreview_chapterItem__9Q\\+4K {
    padding: 12px 15px;
    margin-bottom: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    flex-direction: column;
  }
  
  .BookPreview_chapterItem__9Q\\+4K:hover {
    background-color: #f0f0f0;
  }
  
  .BookPreview_chapterItem__9Q\\+4K.BookPreview_active__MHU-O {
    background-color: #e8e1d9c7;
    position: relative;
  }
  
  .BookPreview_chapterItem__9Q\\+4K.BookPreview_active__MHU-O::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: #b37f67;
    border-radius: 2px;
  }
  
  .BookPreview_chapterNumber__dRlbn {
    font-size: 0.8rem;
    color: #888;
    margin-bottom: 3px;
  }
  
  .BookPreview_chapterTitle__cSjqV {
    font-weight: 500;
    color: #333;
  }
  
  
  /* Reader container styles */
  .BookPreview_readerContainer__0QxxM {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-left: 0;
    transition: margin-left 0.3s ease-in-out;
    width: 100%;
  }
  
  .BookPreview_readerHeader__-uQMV {
    display: flex;
    align-items: center;
    padding: 15px 25px;

    background-color: #fffaf0;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
    z-index: 10;
  }
  
  .BookPreview_libraryButton__eLybX {
    background: none;
    border: none;
    cursor: pointer;
    color: #555;
    transition: color 0.2s;
    padding: 8px;
    border-radius: 50%;
    margin-right: 15px;
  }
  
  .BookPreview_libraryButton__eLybX:hover {
    color: #000;
    background-color: #f0f0f0;
  }
  
  .BookPreview_bookInfo__s8CUL {
    flex-grow: 1;
  }
  
  .BookPreview_bookTitle__3-wZ7 {
    margin: 0;
    font-size: 1rem;
    font-weight: normal;
    color: #888;
  }
  
  .BookPreview_bookInfo__s8CUL .BookPreview_chapterTitle__cSjqV {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
  }
  .BookPreview_bookFullContent__Khewg{
    overflow: hidden;
    padding-bottom: 30px;
  }
  .BookPreview_chapterIndicator__XnSIe {
    font-size: 0.9rem;
    color: #888;
  }
  
  /* Content area styles */
  .BookPreview_contentContainer__5j\\+DQ {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    position: relative;
    overflow: hidden;
  }
  
  .BookPreview_contentScrollbar__NQuoI {
    flex-grow: 1;
    padding: 30px 0;
    background-color: #fffaf0;
  }
  
  .BookPreview_chapterContent__Cz1qr {
    max-width: 800px;
    overflow: hidden;
    margin: 0 auto;
    padding: 0 30px;
    line-height: 37px;
    color: #333333;
    font-size: 22px;
    letter-spacing: 0.5px;
    font-family: 'Raleway,sans-serif';
    font-weight: 500 !important;
  }
  
  .BookPreview_fadeOut__kU3e6 {
    opacity: 0;
  }
  
  .BookPreview_fadeIn__Kk4TI {
    opacity: 1;
  }
  
  .BookPreview_contentChapterTitle__14XOb {
    font-size: 40px;
    font-weight: 700;
    color: #000000;
    font-family: 'Cinzel Decorative', serif;
    letter-spacing: 0.5px;
    line-height: 64px;
    text-align: center;
  }
  
  .BookPreview_paragraph__ozzPS {
    margin-bottom: 1.5em;
    text-align: justify;
    text-indent: 1.5em;
    font-size: 1.1rem;
  }
  
  .BookPreview_navButton__uojHA {
    background: none;
    border: none;
    cursor: pointer;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    padding: 15px 10px;
    color: #b38867;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 5px;
    transition: all 0.2s;
    z-index: 5;
  }
  
  .BookPreview_navButton__uojHA:hover {
    background-color: rgba(255, 255, 255, 0.9);
    color: #8c6647;
  }
  
  .BookPreview_navButton__uojHA.BookPreview_disabled__iWpzu {
    opacity: 0.3;
    cursor: not-allowed;
  }
  
  .BookPreview_prevButton__UOMsi {
    left: 15px;
  }
  
  .BookPreview_nextButton__zjnlr {
    right: 15px;
  }
  
  /* Mobile navigation */
  .BookPreview_mobileNavigation__GWjRg {
    display: none;
    justify-content: space-between;
    padding: 15px;
    background-color: #fff;
    box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);
  }
  
  .BookPreview_mobileNavButton__2zGCR, .BookPreview_mobileMenuButton__f-jSu {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: 1px solid #ddd;
    padding: 8px 15px;
    border-radius: 5px;
    cursor: pointer;
    font-family: 'Merriweather', Georgia, serif;
    transition: all 0.2s;
  }
  
  .BookPreview_mobileNavButton__2zGCR:hover, .BookPreview_mobileMenuButton__f-jSu:hover {
    background-color: #f5f5f5;
  }
  
  .BookPreview_mobileNavButton__2zGCR.BookPreview_disabled__iWpzu {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .BookPreview_mobileMenuButton__f-jSu {
    background-color: #f0e9e0;
    border-color: #d9cfc1;
  }
  
  /* Media queries for responsive design */
  @media (max-width: 1024px) {
    .BookPreview_navButton__uojHA {
      padding: 10px 8px;
    }
    
    .BookPreview_chapterContent__Cz1qr {
      max-width: 600px;
      padding: 0 30px;
    }
  }
  
  @media (max-width: 768px) {
    .BookPreview_librarySidebar__DngGd {
      width: 280px;
    }
    
    .BookPreview_navButton__uojHA {
      display: none;
    }
    
    .BookPreview_mobileNavigation__GWjRg {
      display: flex;
    }
    
    
    .BookPreview_contentScrollbar__NQuoI {
      padding: 20px 0;
    }
    
    .BookPreview_paragraph__ozzPS {
      font-size: 14px;
    }
    
    .BookPreview_contentChapterTitle__14XOb {
      font-size: 18px;
      margin-bottom: 0px;
      line-height: 25px;
    }
    .BookPreview_bookFullContent__Khewg{
      font-size: 20px;
      line-height: 30px;
    }
  }
  
  @media (max-width: 480px) {
    .BookPreview_librarySidebar__DngGd {
      width: 100%;
    }
    .BookPreview_bookFullContent__Khewg{
      font-size: 16px;
      line-height: 25px;
      max-width: 98%;
      padding-bottom: 30px;
    }

    .BookPreview_scrollContainer__8vK-D{
      height: 85vh !important;
      top: 55% !important;
    }
    
    .BookPreview_readerHeader__-uQMV {
      padding: 10px 15px;
    }
    
    .BookPreview_bookTitle__3-wZ7 {
      font-size: 16px;
    }
    
    .BookPreview_bookInfo__s8CUL .BookPreview_chapterTitle__cSjqV {
      font-size: 18px;
    }
    
    .BookPreview_chapterIndicator__XnSIe {
      display: none;
    }
    
    .BookPreview_mobileNavButton__2zGCR, .BookPreview_mobileMenuButton__f-jSu {
      font-size: 0.9rem;
      padding: 8px 12px;
    }
    .BookPreview_chaptercontent__IwIp5{
      line-height: 26px;
      font-size: 18px;
    }
  }

  .BookPreview_backButton__23h-E {
    background: none;
    border: none;
    cursor: pointer;
    color: #555;
    transition: color 0.2s;
    padding: 8px;
    border-radius: 50%;
    margin-right: 10px;
  }
  
  .BookPreview_backButton__23h-E:hover {
    color: #000;
    background-color: #f0f0f0;
  }

  @media (max-width: 480px) {
    .BookPreview_backButton__23h-E {
      padding: 6px;
      margin-right: 5px;
    }
  }
  /* Scroll-related styles */
.BookPreview_scrollThumb__iNU2o {
  overflow: hidden;
}

/* Custom scroll container and elements */
.BookPreview_scrollContainer__8vK-D {
  position: fixed;
  right: 150px;
  top: 59%;
  transform: translateY(-50%);
  height: 70vh; /* Smaller height than full screen */
  width: 30px; /* Wider clickable area */
  z-index: 10;
  cursor: pointer; /* Show pointer cursor for the entire container */
}

.BookPreview_scrollLine__sgzNz {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 0.5px;
  background-color: black;
  transform: translateX(-50%);
}

.BookPreview_scrollCircle__BY2pt {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid black;
  border-radius: 50%;
  background-color: white;
  left: 50%;
  transform: translateX(-50%);
  cursor: grab; /* Show grab cursor */
  z-index: 2; /* Ensure circle is above line */
  touch-action: none; /* Prevent touch actions to avoid interference with dragging */
}

.BookPreview_scrollCircle__BY2pt:active {
  cursor: grabbing; /* Change cursor when actively dragging */
}

/* Custom scrollbar styling */
.BookPreview_customScrollbar__MQIQu {
  width: 100% !important;
  height: 100% !important;
}

.BookPreview_customScrollbar__MQIQu > div::-webkit-scrollbar {
  display: none;
}

.BookPreview_customThumb__0hnng {
  background-color: transparent !important;
  width: 0 !important;
}

/* Responsive adjustments for scroll container */
@media (max-width: 768px) {
  .BookPreview_scrollContainer__8vK-D {
    right: 10px !important;
    top: 55% !important;
    height: 55vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reading/BookPreview.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,2CAA2C;IAC3C,6DAA6D;IAC7D,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA,2BAA2B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2DAA2D;CAC5D,mCAAmC;EAClC,gDAAgD;EAChD,kCAAkC;EAClC,0BAA0B;AAC5B;;EAEE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;;EAGA,4BAA4B;EAC5B;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,wCAAwC;IACxC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,yBAAyB;IACzB,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA,wBAAwB;EACxB;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA,wCAAwC;EACxC;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;;IAGA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,WAAW;IACb;IACA;MACE,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,oBAAoB;IACtB;;IAEA;MACE,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE;MACE,YAAY;MACZ,iBAAiB;IACnB;EACF;EACA,0BAA0B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,YAAY,EAAE,oCAAoC;EAClD,WAAW,EAAE,yBAAyB;EACtC,WAAW;EACX,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,YAAY,EAAE,qBAAqB;EACnC,UAAU,EAAE,gCAAgC;EAC5C,kBAAkB,EAAE,8DAA8D;AACpF;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":[".bookContainer {\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    position: relative;\n    font-family: 'Merriweather', Georgia, serif;\n    background: linear-gradient(135deg, #CAC9C9 0%, #CAC9C9 100%);\n    overflow: hidden;\n    z-index: 9999;\n  }\n  .scrollThumb{\n    overflow: hidden;\n  }\n  \n  /* Library sidebar styles */\n.librarySidebar {\n  position: fixed;\n  width: 320px;\n  height: 100vh;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  /* Updated background properties for glassmorphism effect */\n -webkit-backdrop-filter: blur(15px);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: rgb(0 0 0 / 31%);\n  backdrop-filter: blur(4px);\n}\n  \n  .librarySidebar.active {\n    transform: translateX(0);\n  }\n  \n  .libraryHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .libraryHeader h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #333;\n    font-weight: 700;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #666;\n    transition: color 0.2s;\n  }\n  \n  .closeButton:hover {\n    color: #000;\n  }\n  \n  .chapterList {\n    padding: 20px;\n    overflow-y: auto;\n    flex-grow: 1;\n  }\n  \n  .chapterList h3 {\n    margin: 0 0 5px 0;\n    font-size: 1.2rem;\n    color: #333;\n  }\n  \n  .author {\n    margin: 0 0 20px 0;\n    color: #666;\n    font-style: italic;\n  }\n  \n  .chapterItem {\n    padding: 12px 15px;\n    margin-bottom: 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .chapterItem:hover {\n    background-color: #f0f0f0;\n  }\n  \n  .chapterItem.active {\n    background-color: #e8e1d9c7;\n    position: relative;\n  }\n  \n  .chapterItem.active::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 4px;\n    background-color: #b37f67;\n    border-radius: 2px;\n  }\n  \n  .chapterNumber {\n    font-size: 0.8rem;\n    color: #888;\n    margin-bottom: 3px;\n  }\n  \n  .chapterTitle {\n    font-weight: 500;\n    color: #333;\n  }\n  \n  \n  /* Reader container styles */\n  .readerContainer {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    margin-left: 0;\n    transition: margin-left 0.3s ease-in-out;\n    width: 100%;\n  }\n  \n  .readerHeader {\n    display: flex;\n    align-items: center;\n    padding: 15px 25px;\n\n    background-color: #fffaf0;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);\n    z-index: 10;\n  }\n  \n  .libraryButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #555;\n    transition: color 0.2s;\n    padding: 8px;\n    border-radius: 50%;\n    margin-right: 15px;\n  }\n  \n  .libraryButton:hover {\n    color: #000;\n    background-color: #f0f0f0;\n  }\n  \n  .bookInfo {\n    flex-grow: 1;\n  }\n  \n  .bookTitle {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: normal;\n    color: #888;\n  }\n  \n  .bookInfo .chapterTitle {\n    margin: 0;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #333;\n  }\n  .bookFullContent{\n    overflow: hidden;\n    padding-bottom: 30px;\n  }\n  .chapterIndicator {\n    font-size: 0.9rem;\n    color: #888;\n  }\n  \n  /* Content area styles */\n  .contentContainer {\n    flex-grow: 1;\n    display: flex;\n    align-items: stretch;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .contentScrollbar {\n    flex-grow: 1;\n    padding: 30px 0;\n    background-color: #fffaf0;\n  }\n  \n  .chapterContent {\n    max-width: 800px;\n    overflow: hidden;\n    margin: 0 auto;\n    padding: 0 30px;\n    line-height: 37px;\n    color: #333333;\n    font-size: 22px;\n    letter-spacing: 0.5px;\n    font-family: 'Raleway,sans-serif';\n    font-weight: 500 !important;\n  }\n  \n  .fadeOut {\n    opacity: 0;\n  }\n  \n  .fadeIn {\n    opacity: 1;\n  }\n  \n  .contentChapterTitle {\n    font-size: 40px;\n    font-weight: 700;\n    color: #000000;\n    font-family: 'Cinzel Decorative', serif;\n    letter-spacing: 0.5px;\n    line-height: 64px;\n    text-align: center;\n  }\n  \n  .paragraph {\n    margin-bottom: 1.5em;\n    text-align: justify;\n    text-indent: 1.5em;\n    font-size: 1.1rem;\n  }\n  \n  .navButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    position: fixed;\n    top: 50%;\n    transform: translateY(-50%);\n    padding: 15px 10px;\n    color: #b38867;\n    background-color: rgba(255, 255, 255, 0.7);\n    border-radius: 5px;\n    transition: all 0.2s;\n    z-index: 5;\n  }\n  \n  .navButton:hover {\n    background-color: rgba(255, 255, 255, 0.9);\n    color: #8c6647;\n  }\n  \n  .navButton.disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n  }\n  \n  .prevButton {\n    left: 15px;\n  }\n  \n  .nextButton {\n    right: 15px;\n  }\n  \n  /* Mobile navigation */\n  .mobileNavigation {\n    display: none;\n    justify-content: space-between;\n    padding: 15px;\n    background-color: #fff;\n    box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .mobileNavButton, .mobileMenuButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: 1px solid #ddd;\n    padding: 8px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-family: 'Merriweather', Georgia, serif;\n    transition: all 0.2s;\n  }\n  \n  .mobileNavButton:hover, .mobileMenuButton:hover {\n    background-color: #f5f5f5;\n  }\n  \n  .mobileNavButton.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .mobileMenuButton {\n    background-color: #f0e9e0;\n    border-color: #d9cfc1;\n  }\n  \n  /* Media queries for responsive design */\n  @media (max-width: 1024px) {\n    .navButton {\n      padding: 10px 8px;\n    }\n    \n    .chapterContent {\n      max-width: 600px;\n      padding: 0 30px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .librarySidebar {\n      width: 280px;\n    }\n    \n    .navButton {\n      display: none;\n    }\n    \n    .mobileNavigation {\n      display: flex;\n    }\n    \n    \n    .contentScrollbar {\n      padding: 20px 0;\n    }\n    \n    .paragraph {\n      font-size: 14px;\n    }\n    \n    .contentChapterTitle {\n      font-size: 18px;\n      margin-bottom: 0px;\n      line-height: 25px;\n    }\n    .bookFullContent{\n      font-size: 20px;\n      line-height: 30px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .librarySidebar {\n      width: 100%;\n    }\n    .bookFullContent{\n      font-size: 16px;\n      line-height: 25px;\n      max-width: 98%;\n      padding-bottom: 30px;\n    }\n\n    .scrollContainer{\n      height: 85vh !important;\n      top: 55% !important;\n    }\n    \n    .readerHeader {\n      padding: 10px 15px;\n    }\n    \n    .bookTitle {\n      font-size: 16px;\n    }\n    \n    .bookInfo .chapterTitle {\n      font-size: 18px;\n    }\n    \n    .chapterIndicator {\n      display: none;\n    }\n    \n    .mobileNavButton, .mobileMenuButton {\n      font-size: 0.9rem;\n      padding: 8px 12px;\n    }\n    .chaptercontent{\n      line-height: 26px;\n      font-size: 18px;\n    }\n  }\n\n  .backButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #555;\n    transition: color 0.2s;\n    padding: 8px;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n  \n  .backButton:hover {\n    color: #000;\n    background-color: #f0f0f0;\n  }\n\n  @media (max-width: 480px) {\n    .backButton {\n      padding: 6px;\n      margin-right: 5px;\n    }\n  }\n  /* Scroll-related styles */\n.scrollThumb {\n  overflow: hidden;\n}\n\n/* Custom scroll container and elements */\n.scrollContainer {\n  position: fixed;\n  right: 150px;\n  top: 59%;\n  transform: translateY(-50%);\n  height: 70vh; /* Smaller height than full screen */\n  width: 30px; /* Wider clickable area */\n  z-index: 10;\n  cursor: pointer; /* Show pointer cursor for the entire container */\n}\n\n.scrollLine {\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  width: 0.5px;\n  background-color: black;\n  transform: translateX(-50%);\n}\n\n.scrollCircle {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border: 2px solid black;\n  border-radius: 50%;\n  background-color: white;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: grab; /* Show grab cursor */\n  z-index: 2; /* Ensure circle is above line */\n  touch-action: none; /* Prevent touch actions to avoid interference with dragging */\n}\n\n.scrollCircle:active {\n  cursor: grabbing; /* Change cursor when actively dragging */\n}\n\n/* Custom scrollbar styling */\n.customScrollbar {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.customScrollbar > div::-webkit-scrollbar {\n  display: none;\n}\n\n.customThumb {\n  background-color: transparent !important;\n  width: 0 !important;\n}\n\n/* Responsive adjustments for scroll container */\n@media (max-width: 768px) {\n  .scrollContainer {\n    right: 10px !important;\n    top: 55% !important;\n    height: 55vh !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookContainer": `BookPreview_bookContainer__eStP6`,
	"scrollThumb": `BookPreview_scrollThumb__iNU2o`,
	"librarySidebar": `BookPreview_librarySidebar__DngGd`,
	"active": `BookPreview_active__MHU-O`,
	"libraryHeader": `BookPreview_libraryHeader__gg2GP`,
	"closeButton": `BookPreview_closeButton__+dDyu`,
	"chapterList": `BookPreview_chapterList__P-t4U`,
	"author": `BookPreview_author__A3q9+`,
	"chapterItem": `BookPreview_chapterItem__9Q+4K`,
	"chapterNumber": `BookPreview_chapterNumber__dRlbn`,
	"chapterTitle": `BookPreview_chapterTitle__cSjqV`,
	"readerContainer": `BookPreview_readerContainer__0QxxM`,
	"readerHeader": `BookPreview_readerHeader__-uQMV`,
	"libraryButton": `BookPreview_libraryButton__eLybX`,
	"bookInfo": `BookPreview_bookInfo__s8CUL`,
	"bookTitle": `BookPreview_bookTitle__3-wZ7`,
	"bookFullContent": `BookPreview_bookFullContent__Khewg`,
	"chapterIndicator": `BookPreview_chapterIndicator__XnSIe`,
	"contentContainer": `BookPreview_contentContainer__5j+DQ`,
	"contentScrollbar": `BookPreview_contentScrollbar__NQuoI`,
	"chapterContent": `BookPreview_chapterContent__Cz1qr`,
	"fadeOut": `BookPreview_fadeOut__kU3e6`,
	"fadeIn": `BookPreview_fadeIn__Kk4TI`,
	"contentChapterTitle": `BookPreview_contentChapterTitle__14XOb`,
	"paragraph": `BookPreview_paragraph__ozzPS`,
	"navButton": `BookPreview_navButton__uojHA`,
	"disabled": `BookPreview_disabled__iWpzu`,
	"prevButton": `BookPreview_prevButton__UOMsi`,
	"nextButton": `BookPreview_nextButton__zjnlr`,
	"mobileNavigation": `BookPreview_mobileNavigation__GWjRg`,
	"mobileNavButton": `BookPreview_mobileNavButton__2zGCR`,
	"mobileMenuButton": `BookPreview_mobileMenuButton__f-jSu`,
	"scrollContainer": `BookPreview_scrollContainer__8vK-D`,
	"chaptercontent": `BookPreview_chaptercontent__IwIp5`,
	"backButton": `BookPreview_backButton__23h-E`,
	"scrollLine": `BookPreview_scrollLine__sgzNz`,
	"scrollCircle": `BookPreview_scrollCircle__BY2pt`,
	"customScrollbar": `BookPreview_customScrollbar__MQIQu`,
	"customThumb": `BookPreview_customThumb__0hnng`
};
export default ___CSS_LOADER_EXPORT___;
